import React from 'react';
import PropTypes from 'prop-types';

const IMAGE_WIDTH = 410;
const IMAGE_HEIGHT = 272;

import './storefront.scss';

export default class StorefrontNewAppHighlights extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object.isRequired,
  };

  renderImage(highlight) {
    const { app } = this.props;

    const highlightAsset = app.highlight_assets?.find(
      ({ id }) => id === highlight.id,
    );
    if (!highlightAsset?.image) {
      return null;
    }

    const highlightImageUrl = `${highlightAsset.image.url}?width=${
      IMAGE_WIDTH * 2
    }&height=${IMAGE_HEIGHT * 2}`;

    return <img src={highlightImageUrl} alt={highlight.title} />;
  }

  render() {
    const { app } = this.props;

    if (!app.highlights?.length) {
      return null;
    }

    return (
      <>
        <h2>{app.type === 'theme' ? 'Theme features' : 'App features'}</h2>
        <div className="storefront-apps-highlights">
          {app.highlights.map((highlight, index) => (
            <div key={index} className="storefront-apps-highlight-item">
              <div className="storefront-apps-highlight-image">
                {this.renderImage(highlight)}
              </div>
              <div key={index} className="storefront-apps-highlight-content">
                <div className="storefront-apps-highlight-title">
                  {highlight.title}
                </div>
                <div className="storefront-apps-highlight-description">
                  {highlight.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }
}
